export default "__VITE_ASSET__CrJxEWCI__"